import { Persistore } from 'persistore';
import * as Intl from 'first-intl';
import intlData from './intl-de.json';
import { _ } from '@hugendubel/utils';
import { Token, WsClient } from '@hugendubel/ws_client';
import { AuthService } from '@hugendubel/login';
import { Modal } from '@hugendubel/react-basic';
import { Track, TRACK_ID } from '@hugendubel/tracking_client';
import { LoyaltyIFrameService } from './services/loyalty-iFrame-service';
import { Store } from './store';
import { isAuthenticated } from './ws/WS';

export const onUpdate = (authenticated: boolean, wsToken?: Token): void => Store.set({ wsToken });

export const cleanUpFromAuth = () => {
    Modal.close();
};

export const configurePackages = () => {
    _.configure({ onError: (desc: string) => Track.error(TRACK_ID('2019-09-06 12:13:49'), desc) });
    AuthService.configure({
        isLoggedIn: isAuthenticated,
        fullLogout: !LoyaltyIFrameService.insideIFrame(),
        onUpdate,
        cleanUpFromAuth,
    });
    WsClient.init({
        onLogout: AuthService.onWsClientLogout,
        onUpdate: AuthService.onWsClientUpdate,
        allowSessionToken: true,
        cred: {
            username: process.env.IS_HUDU ? 'Hudu-Mobile-Shop-Vollsortiment' : 'Mobile-Shop-Vollsortiment',
        },
    });
    Track.configure({
        appName: 'bonus-shop',
        loginAccessor: AuthService.isLoggedIn,
        prod: process.env.NODE_ENV !== 'development',
    });
    Persistore.config({ insecure: process.env.NODE_ENV === 'development' });
    Intl.configure({ tracker: (desc: string) => Track.error(TRACK_ID('2019-09-06 12:14:03'), desc) });
    Intl.addIntlData(intlData);
};

configurePackages();
